import Head from "next/head";
import { useMemo } from "react";
import cn from "classnames";

import { LazyLoadAfterTrigger } from "@/src/component/partial/LazyLoadAfterTrigger";
import CMSLogic from "@/src/logic/CMSLogic";
import { StrapiComponentType } from "@/src/type";

import styles from "./ImageBreakpointModule.module.scss";

interface ImageBreakpointModuleProps {
  images: Array<StrapiComponentType.Element.ImageBreakpoint>;
  stylePrefix?: string;
  id: string | number;
  classes?: {
    container?: string;
  };
  preload?: boolean;
  mobileHint?: boolean;
  quality: number;
  lazy?: "eager" | "lazy";
}

function ImageBreakpointModule({ images, stylePrefix, id, classes, quality, lazy }: ImageBreakpointModuleProps) {
  const name = useMemo(() => `${stylePrefix ?? "ImageBreakpointModule"}_${id}`, [stylePrefix, id]);
  const style = CMSLogic.generateAssetBreakpointStyle(name, quality, images);

  if (!style) {
    return <></>;
  }

  return (
    <LazyLoadAfterTrigger
      lazy={lazy ?? "lazy"}
      triggers={["swiperSlideChange", "click", "touchstart", "scroll"]}
      autoTrigger={true}
    >
      <Head>
        <style
          id={`${name}`}
          type="text/css"
          dangerouslySetInnerHTML={{ __html: style }}
        />
      </Head>
      <div className={cn(classes?.container, name, styles.image)} />
    </LazyLoadAfterTrigger>
  );
}

export default ImageBreakpointModule;
